var locale = {
  placeholder: 'Select time'
};
export default locale;
//# sourceMappingURL=en_US.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/time-picker/locale/en_US.js
// module id = 199
// module chunks = 3